import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalexperiencephysical-card',
  templateUrl: './helpbutton-reports-totalexperiencephysical-card.component.html',
  styleUrls: ['./helpbutton-reports-totalexperiencephysical-card.component.scss']
})
export class HelpbuttonReportsTotalexperiencephysicalCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
